import React from 'react';
import { aboutText } from '../mock';

const About = () => {
  return (
    <section className="py-32 px-6 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-24 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-5xl md:text-6xl font-serif font-normal text-primary mb-12 leading-tight">
              {aboutText.title}
            </h2>
            <div className="space-y-8">
              {aboutText.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg text-muted-foreground font-light leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
            <div className="mt-12 h-px w-24 bg-accent"></div>
          </div>
          <div className="relative order-1 md:order-2">
            <div className="aspect-[3/4] overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/xr2tulb6_unnamed.jpg"
                alt="Csapatunk"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-full h-full border border-border -z-10 hidden md:block"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
